import React, { useState, useEffect } from 'react';
import { Row, Col, Select, Button, Input, Collapse } from 'antd';

import JsonViewer from '../../sharedComponent/JsonView';

import { enterpriseList } from '../../actions/sessionActions';
import { getNoAuth } from '../../utils/httpRequests';
import { APIs } from '../../utils/apis';
import { capitalize } from '../../utils/assetUtils';

const { Option } = Select;
const { Panel } = Collapse;

const enums = {
  1: 'Other mode (Manually)',
  2: 'COD - Refund via Payout links',
  3: 'PREPAID - Refund to original payment mode using Shopify (Prepaid Order)',
  4: 'Discount code',
  5: 'Gift card',
  6: 'Refund using bank account transfer',
  7: 'Refund using UPI transfer',
  8: 'NOT IN USE - Refund using refund to source account method',
  9: 'Brand Credits'
};

const Configs = () => {
  const [state, setState] = useState({
    isFetching: false,
    domain: null,
    configs: null,
    enterprise: { list: [] },
    enterpriseId: null
  });

  useEffect(() => {
    pageInit();
  }, []);

  const pageInit = () => {
    enterpriseList('enterprise').then(result => {
      if (result?.meta?.status === 200) {
        setState({
          ...state,
          enterprise: {
            ...state.enterprise,
            list: result.result.enterprises
          }
        });
      }
    });
  };

  const getConfigs = () => {
    setState({ ...state, isFetching: true, configs: null, enterpriseId: null });
    getNoAuth({
      url: `${APIs.RETURN_CONFIGS}domain=${state.domain}`,
      data: { subdomain: state.domain },
      headers: { 'Content-Type': 'application/json' }
    })
      .then(response => {
        if (!response) {
          throw Error(response.statusText);
        }
        setState({
          ...state,
          configs: response?.data?.result,
          isFetching: false
        });
      })
      .catch(function(error) {
        return error;
      });
  };

  const handleChange = value => {
    const filteredEnterprise = state.enterprise.list.filter(
      item => item.id === value
    );
    setState({
      ...state,
      domain: filteredEnterprise?.[0]?.key,
      enterpriseId: value
    });

    getNoAuth({
      url: `${APIs.TRACKING_PAGE_STYLING}key=${filteredEnterprise?.[0]?.key}`,
      headers: { 'Content-Type': 'application/json' }
    })
      .then(response => {
        if (!response) {
          throw Error(response.statusText);
        }
        setState({ ...state, domain: response?.data?.result?.subdomain });
      })
      .catch(function(error) {
        return error;
      });
  };
  const onChange = e => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  const getLabel = value => value.replace(/_/g, ' ');

  return (
    <div>
      <h2>Returns & Exchange Configs</h2>
      <i className="margin-bottom-10">
        Find what all Automation Configs have been set for any Enterprise which
        has subscribed to Returns and Exchange
      </i>
      <a
        href="https://clickpost.atlassian.net/wiki/spaces/PS/pages/2243330099/Refund+Automation+Onboarding+Doc"
        target="_blank"
        rel="noreferrer"
        className="margin-left-10"
      >
        Onboarding Doc - LINK
      </a>
      <Row className="margin-bottom-20  margin-top-20">
        <Col span={24} className="margin-bottom-10">
          <strong>
            Enter subdomain (tracking page subdomain) or select Enterprise to
            get configs
          </strong>
        </Col>
        <Col span={11}>
          <Input
            name="domain"
            placeholder={`Enter subdomain here`}
            className="ant-input"
            value={state.domain}
            onChange={onChange}
          />
        </Col>
        <Col span={2} className="text-center">
          <span>OR</span>
        </Col>
        <Col span={11} className="margin-bottom-10">
          <Select
            name="enterpriseId"
            id="enterpriseId"
            showSearch
            style={{ width: '96%' }}
            placeholder="Select Enterprise"
            optionFilterProp="children"
            onChange={value => handleChange(value)}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
            defaultValue={state.enterpriseId || undefined}
          >
            {state.enterprise.list.map((enterprise, i) => (
              <Option key={i} value={enterprise.id}>
                {enterprise.name}
              </Option>
            ))}
          </Select>
        </Col>
        <Col span={24} className="margin-bottom-20  margin-top-20 text-center">
          <Button type="primary" onClick={getConfigs} disabled={!state.domain}>
            Get Configs
          </Button>
        </Col>
      </Row>
      <hr />
      {state.isFetching ? (
        'Fetching ...'
      ) : (
        <Row>
          {state.configs ? (
            <div>
              <Col span={24} className="margin-bottom-20">
                <h2>Configs</h2>
                <h3>Subdomain: {state.domain}</h3>
              </Col>
              <Row>
                <Col span={11} className="margin-right-10">
                  <h2>Table View</h2>
                  {Object.keys(state.configs ?? {}).map(key => (
                    <Collapse
                      accordion
                      defaultActiveKey={key}
                      expandIconPosition={'right'}
                      key={key}
                    >
                      <Panel
                        header={<div>{capitalize(getLabel(key))}</div>}
                        className="audit-logs"
                      >
                        <table
                          className={`ant-table ant-table-small width-100pt margin-bottom-20`}
                          key={key}
                        >
                          <tbody className="ant-table-tbody">
                            {state.configs[key]?.length > 0 ? (
                              state.configs[key]?.map(item =>
                                Object.keys(item ?? {})?.length > 0 ? (
                                  Object.keys(item ?? {}).map(innerItem => (
                                    <tr className="padding-8" key={innerItem}>
                                      <td width="40%">
                                        {capitalize(getLabel(innerItem))}
                                      </td>
                                      <td>
                                        {Array.isArray(item?.[innerItem]) ? (
                                          item?.[innerItem]
                                            ?.map(
                                              value => enums?.[value] || value
                                            )
                                            .join(', ')
                                        ) : typeof item?.[innerItem] ===
                                          'object' ? (
                                          <pre>
                                            {JSON.stringify(
                                              item?.[innerItem],
                                              null,
                                              2
                                            )}
                                          </pre>
                                        ) : (
                                          item?.[innerItem]?.toLocaleString() ||
                                          'Not Set'
                                        )}
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr className="padding-8" key={item}>
                                    <td colSpan={2}>No Data</td>
                                  </tr>
                                )
                              )
                            ) : (
                              <tr className="padding-8">
                                <td colSpan={2}>No Data</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </Panel>
                    </Collapse>
                  ))}
                </Col>
                <Col span={11} className="">
                  <h2>JSON View</h2>
                  <JsonViewer
                    data={state.configs}
                    className={{ code: 'full-height' }}
                  />
                </Col>
              </Row>
            </div>
          ) : state.domain ? (
            <div>
              <h3>No Configs found for {state.domain}</h3>
            </div>
          ) : (
            'Search for Configs using the options above'
          )}
        </Row>
      )}
    </div>
  );
};

export default Configs;
